import { useEffect } from 'react';
import { ChevronRightIcon } from '@heroicons/react/20/solid';
import type { User } from '@core/generated/gql-types';
import { useNoteStore } from '@core/note/useNoteStore';
import Button from '@/components/Button';
import NoteItem from '../../notes/NoteItem';

interface LatestNoteProps {
  worker: User;
  onViewNotes: () => void;
}

const LatestNote = ({ worker, onViewNotes }: LatestNoteProps) => {
  const { ensureNotesForObject, getNotesForObject } = useNoteStore();
  const latestNote = getNotesForObject(worker.id)[0];

  useEffect(() => {
    void ensureNotesForObject(worker.id).catch(() => undefined);
  }, [ensureNotesForObject, worker.id]);

  if (!latestNote) {
    return null;
  }

  return (
    <section className="rounded-lg bg-white shadow-sm">
      <div className="border-b border-gray-200 px-6 py-4">
        <h2 className="text-xl font-semibold text-gray-900">Latest Note</h2>
      </div>
      <div className="p-6">
        <NoteItem note={latestNote} />
        <Button
          className="mt-3 gap-1 !p-0 text-sm font-medium"
          onClick={onViewNotes}
          variant="text"
        >
          View notes
          <ChevronRightIcon className="h-4 w-4" />
        </Button>
      </div>
    </section>
  );
};

export default LatestNote;
